























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import '@/types';

import { DxDataGrid, DxColumn, DxEditing, DxStateStoring, DxColumnChooser, DxColumnFixing, DxSearchPanel, DxFilterRow, DxExport, DxGroupPanel } from 'devextreme-vue/data-grid';
// Registers the dxTagBox widget (jQuery-style component registry) so it can be instantiated by name
// from editorPreparingFunction below, without adding an unused Vue component to the template.
import 'devextreme/ui/tag_box';

// The filter row cannot use DevExtreme's built-in 'anyof'/'noneof' multi-value operators. Those are
// filter *builder* custom operations (ui.grid_core.filter_custom_operations.js builds them on top of
// baseOperation, which is flagged isFilterBuilder), and the filter row never consults their
// calculateFilterExpression: it emits a raw [dataField, selectedFilterOperation, value] triple
// (ui.grid_core.filter_sync.js, getConditionFromFilterRow). That triple reaches the server verbatim,
// where DevExtreme.AspNet.Data 2.7.1's FilterExpressionCompiler.TranslateBinaryOperation has no case
// for 'anyof' and throws "System.NotSupportedException: Specified method is not supported." (HTTP 500).
//
// So the multi-value expression is built here instead, through the column's own
// calculateFilterExpression hook - which the grid does honour, see
// ui.grid_core.columns_controller.js createFilterExpression - turning the tag box's array into a
// plain OR-group of '=' comparisons that DataSourceLoader already understands.
//
// This list is kept only to migrate grid state persisted while the 'anyof' approach was live.
const LEGACY_MULTI_SELECT_FILTER_OPERATIONS = ['anyof', 'noneof'];

@Component({
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxStateStoring,
    DxColumnChooser,
    DxColumnFixing,
    DxSearchPanel,
    DxFilterRow,
    DxExport,
    DxGroupPanel,
  },
})
export default class DefaultDatagrid extends Vue {
  public selectedRows: any = [];
  @Prop({ required: false, default: false })
  public enableSelection?: boolean;

  @Prop({ required: false, default: false })
  public allowExport!: boolean;

  @Prop({ required: false, default: false })
  public remoteOperations?: boolean;

  @Prop({ required: true })
  public name?: string;

  @Prop({ required: true })
  public columns?: any[];

  @Prop({ required: true })
  public datasource?: any;

  @Prop({ required: false, default: null })
  public grouping?: any;

  @Prop({ required: false, default: false })
  public allowDeleting?: boolean;

  @Prop({ required: false, default: false })
  public allowEditing?: boolean;

  @Prop({ required: false, default: false })
  public allowAdding?: boolean;

  @Prop({ required: false, default: true })
  public onRowRemoving?: any;

  @Prop({ required: false, default: true })
  public onRowInit?: any;

  @Prop({ required: false, default: true })
  public onRowUpdating?: any;

  @Prop({ required: false, default: true })
  public onRowInserting?: any;

  @Prop({ required: false, default: true })
  public onRowUpdated?: any;

  @Prop({ required: false, default: true })
  public onRowClick?: any;

  @Prop({ required: false, default: true })
  public onRowInserted?: any;

  @Prop({ required: false, default: true })
  public onRowRemoved?: any;

  @Prop({ required: false, default: () => () => true })
  public onEditorPreparing?: any;

  @Prop({ required: false, default: null })
  public onCellClick?: any;

  @Prop({ required: false, default: null })
  public onCellPrepared?: any;

  @Prop({ required: false, default: null })
  public onRowPrepared?: any;

  @Prop({ required: false, default: 'row' })
  public editMode?: string;

  @Prop({ required: false, default: false })
  public small?: boolean;

  @Prop({ required: false, default: false })
  public medium?: boolean;

  @Prop({ required: false, default: false })
  public toolbarOptions?: any[];

  @Prop({ required: false, default: null })
  public rowDragging?: any;

  @Prop({ required: false, default: true })
  public showSearchPanel?: any[];

  @Prop({ required: false, default: false })
  public groupPanelvisible?: boolean;

  @Prop({ required: false, default: null })
  public onContentReady?: (e: any) => void;

  @Prop({ required: false, default: true })
  public enableToolbar?: boolean;

  @Prop({ required: false, default: null })
  public onSelectionChanged?: (e: any) => void;

  @Prop({ required: false, default: null })
  public onInitialized?: (e: any) => void;

  public showFilter: boolean = true;

  public paging: any = {
    pageSize: 20,
  };
  public pager: any = {
    showPageSizeSelector: true,
    allowedPageSizes: [10, 20, 50],
    visible: true,
  };

  // Lookup columns keep DevExtreme's default '=' operation and carry an array filterValue, which
  // `calculateFilterExpression` (see `processedColumns`) turns into an OR-group. Grid state stored by
  // an earlier build can still hold 'anyof'/'noneof' as the selected operation: 'anyof' would be sent
  // to the server verbatim and answered with HTTP 500, and neither operation is offered by the column
  // any more. Both are stripped here so a stored filter cannot resurrect the broken request.
  private sanitizeStoredLookupFilters(state: any) {
    if (!state || !Array.isArray(state.columns) || !Array.isArray(this.columns)) {
      return;
    }

    const lookupDataFields = new Set(
      this.columns.filter((column: any) => column && column.lookup && column.dataField).map((column: any) => column.dataField),
    );

    state.columns.forEach((storedColumn: any) => {
      if (!storedColumn || !lookupDataFields.has(storedColumn.dataField)) {
        return;
      }

      if (LEGACY_MULTI_SELECT_FILTER_OPERATIONS.indexOf(storedColumn.selectedFilterOperation) === -1) {
        // Anything else - no operation, or a plain '=' from before multi-select existed - is already
        // valid: calculateFilterExpression handles both a scalar and an array filterValue.
        return;
      }

      // 'anyof' selected an include set, which the default '=' plus an array filterValue now expresses,
      // so the values are kept and only the operation is dropped. 'noneof' meant exclude, which is no
      // longer supported at all; silently turning it into an include filter would show the user the
      // opposite of what they saved, so that filter is cleared instead.
      const wasExclude = storedColumn.selectedFilterOperation === 'noneof';

      delete storedColumn.selectedFilterOperation;
      delete storedColumn.bufferedSelectedFilterOperation;

      if (wasExclude) {
        delete storedColumn.filterValue;
        delete storedColumn.bufferedFilterValue;
      }
    });
  }

  public loadState() {
    if (!this.name) {
      return null;
    }

    let state: any = localStorage.getItem(this.name);
    if (state) {
      state = JSON.parse(state);
      if (state && state.selectedRowKeys && Array.isArray(state.selectedRowKeys) && state.selectedRowKeys.length > 0) {
        state.selectedRowKeys = [];
      }

      if (state.hasOwnProperty('searchText')) {
        state.searchText = '';
      }

      this.sanitizeStoredLookupFilters(state);
    }

    return state;
  }

  public saveState(state: any) {
    if (this.name) {
      localStorage.setItem(this.name, JSON.stringify(state));
    }
  }

  // Defaults every lookup column to the multi-select filter-row operators, so the filter row lets users
  // pick several values at once instead of exactly one. Columns that already specify their own
  // `filterOperations`/`selectedFilterOperation` (an explicit per-table opt-out or customisation) are
  // left untouched.
  get processedColumns() {
    if (!Array.isArray(this.columns)) {
      return this.columns;
    }

    return this.columns.map((column: any) => {
      if (!column || typeof column !== 'object' || !column.lookup) {
        return column;
      }

      const processedColumn = { ...column };
      const dataField = processedColumn.dataField;

      // The filter row refuses to hand an array back to its editor when the column's dataType is one
      // of BETWEEN_OPERATION_DATA_TYPES - "date", "datetime" or "number" (ui.grid_core.filter_row.js,
      // isValidFilterValue). A lookup whose valueExpr holds numbers, such as an enum, is inferred as
      // 'number', so getFilterValue returned null for our array: the filter itself worked, but every
      // re-render pushed null into the tag box (_columnOptionChanged -> _updateEditorValue) and the
      // selection appeared to vanish behind the placeholder. Declaring the column 'object' keeps it
      // out of that set, so the stored array survives the round trip and the tags stay visible.
      //
      // Safe for a lookup column: the displayed text comes from the lookup, sorting from its
      // displayExpr, and the query from calculateFilterExpression below - none of which consult
      // dataType. It also leaves the column with no default filterOperations, so no filter-operation
      // chooser appears in the filter row, matching how these columns looked before.
      if (!processedColumn.dataType) {
        processedColumn.dataType = 'object';
      }

      // No filterOperations / selectedFilterOperation are set: the column keeps DevExtreme's default
      // '=' for a lookup column, so nothing unknown to the server is ever sent as the operator. The
      // multi-value part lives entirely in calculateFilterExpression below.
      if (dataField && !processedColumn.calculateFilterExpression) {
        processedColumn.calculateFilterExpression = (filterValue: any, selectedFilterOperation: string) => {
          if (!Array.isArray(filterValue)) {
            // Single value, or state saved before multi-select existed - behave exactly as before.
            return [dataField, selectedFilterOperation || '=', filterValue];
          }

          if (filterValue.length === 0) {
            return null;
          }

          if (filterValue.length === 1) {
            return [dataField, '=', filterValue[0]];
          }

          const expression: any[] = [];
          filterValue.forEach((value: any) => {
            if (expression.length > 0) {
              expression.push('or');
            }
            expression.push([dataField, '=', value]);
          });

          return expression;
        };
      }

      return processedColumn;
    });
  }

  // DevExtreme 20.2's filter row always renders a single-select dxSelectBox for lookup columns
  // (ui.editor_factory_mixin.js: `if (options.lookup) prepareSelectBox(options)`, which hard-codes
  // editorName = 'dxSelectBox'). To get an actual multi-select editor we swap it for a dxTagBox here:
  // onEditorPreparing is executed after that preparation but before createEditorCore, so a changed
  // editorName is honoured. The array this produces is turned into a filter expression by the
  // column's calculateFilterExpression - see processedColumns.
  //
  // Note the payload shape: for the filter row DevExtreme does not pass `e.column`. Its
  // _getEditorOptions (ui.grid_core.filter_row.js) builds the editor options by spreading the column
  // itself in - extend(accessibilityOptions, column, { value, parentType, setValue, ... }) - so the
  // lookup config, dataField and dataType all sit at the top level of `e`. Reading `e.column.lookup`
  // here is always undefined, which is why an earlier version of this swap silently never ran and the
  // filter row kept its single-select editor. `e.column` is still checked as a fallback because other
  // parent types (dataRow, headerFilter) do pass one.
  public editorPreparingFunction(e: any) {
    const lookup = e ? e.lookup || (e.column && e.column.lookup) : null;

    if (e && e.parentType === 'filterRow' && lookup) {
      // Prefer e.filterValue over e.value. Both come from the same payload - _getEditorOptions spreads
      // the column in (so filterValue is the column's own stored value) and then overwrites `value`
      // with getFilterValue(), which nulls arrays for some data types. filterValue is the unfiltered
      // truth, so the tag box shows the real selection again after a re-render.
      const storedValue = Array.isArray(e.filterValue) ? e.filterValue : e.value;
      const currentValue: any[] = Array.isArray(storedValue) ? storedValue : storedValue !== undefined && storedValue !== null ? [storedValue] : [];
      const setValue = e.setValue;

      // Build the tag box's dataSource straight from the column's own lookup config rather than reusing
      // editorOptions.dataSource: the select-box editor DevExtreme already prepared unshifts a `null`
      // "(Alle)" entry into that list (its stand-in for "no filter"), which has no meaning once several
      // values can be selected at once - clearing the tag box already achieves that.
      //
      // A lookup can be configured with either `dataSource` or the plain-array shorthand `items`
      // (DevExtreme's own select-box editor accepts both). Falling back to `items` here is required -
      // without it, any column whose lookup only sets `items` (several across the app: task template
      // team/user, contract status, action point status/user) gets an empty dxTagBox with "Geen
      // gegevens om te tonen", even though the column displays and single-value-filters fine.
      let dataSource = lookup.dataSource || lookup.items;
      if (typeof dataSource === 'function') {
        dataSource = dataSource({});
      }

      e.editorName = 'dxTagBox';
      e.editorOptions = {
        ...e.editorOptions,
        dataSource,
        valueExpr: lookup.valueExpr,
        displayExpr: lookup.displayExpr,
        value: currentValue,
        showSelectionControls: true,
        applyValueMode: 'useButtons',
        // A drop-down editor sizes its popup to the input by default, and a filter-row cell is only
        // as wide as its column - narrow ones (Bron, Status) clipped the item labels away entirely
        // and cut the OK / Annuleren buttons in half. dropDownOptions is extended over the widget's
        // own popup config (ui.drop_down_editor.js: extend(this._popupConfig(), dropDownOptions)), so
        // these win. 'auto' sizes to the longest label, with a floor that always fits both buttons
        // and a ceiling so a long value cannot produce an absurdly wide popup.
        dropDownOptions: {
          width: 'auto',
          minWidth: 240,
          maxWidth: 420,
        },
        // Long labels wrap inside the popup instead of being clipped at maxWidth.
        wrapItemText: true,
        onValueChanged: (args: any) => {
          setValue(args.value && args.value.length ? args.value : null);
        },
      };
    }

    if (this.onEditorPreparing && typeof this.onEditorPreparing === 'function') {
      this.onEditorPreparing(e);
    }
  }

  public rowInit(e: any) {
    if (this.onRowInit && typeof this.onRowInit === 'function') {
      this.onRowInit(e);
    }
  }

  public rowInserted(e: any) {
    if (this.onRowInserted && typeof this.onRowInserted === 'function') {
      this.onRowInserted(e);
    }
  }

  public rowUpdated(e: any) {
    if (this.onRowUpdated && typeof this.onRowUpdated === 'function') {
      this.onRowUpdated(e);
    }
  }

  public rowClick(e: any) {
    if (this.onRowClick && typeof this.onRowClick === 'function') {
      this.onRowClick(e);
    }
  }

  public rowRemoved(e: any) {
    if (this.onRowRemoved && typeof this.onRowRemoved === 'function') {
      this.onRowRemoved(e);
    }
  }

  public rowRemoving(e: any) {
    if (this.onRowRemoving && typeof this.onRowRemoving === 'function') {
      this.onRowRemoving(e);
    }
  }

  public rowUpdating(e: any) {
    if (this.onRowUpdating && typeof this.onRowUpdating === 'function') {
      this.onRowUpdating(e);
    }
  }

  public rowInserting(e: any) {
    if (this.onRowInserting && typeof this.onRowInserting === 'function') {
      this.onRowInserting(e);
    }
  }

  public cellPreparedFunction(e: any) {
    if (this.onCellPrepared) {
      this.onCellPrepared(e);
    }
  }

  public rowPreparedFunction(e: any) {
    if (this.onRowPrepared) {
      this.onRowPrepared(e);
    }
  }

  public contentReady(e: any) {
    if (this.onContentReady) {
      this.onContentReady(e);
    }

    this.checkClearFilterButtonStyle();
  }

  public selectionChanged(e: any) {
    if (this.onSelectionChanged) {
      this.onSelectionChanged(e);
    }
  }

  public initialized(e: any) {
    if (this.onInitialized) {
      this.onInitialized(e);
    }
  }

  get height() {
    if (this.small) {
      return 400;
    }

    if (this.medium) {
      return 600;
    }
    // return 600;
  }

  public onToolbarPreparing(e: any) {
    if (!this.enableToolbar) {
      e.toolbarOptions.visible = false;
      return;
    }

    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'fas fa-filter',
        onClick: this.toggleFilter,
      },
    });

    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'fas fa-filter-circle-xmark',
        onClick: this.removeFilters,
        elementAttr: {
          id: 'clearFilterButton',
        },
        onContentReady: this.checkClearFilterButtonStyle,
      },
    });

    if (this.toolbarOptions) {
      this.toolbarOptions.forEach((element) => {
        e.toolbarOptions.items.push(element);
      });
    }
  }

  checkClearFilterButtonStyle() {
    setTimeout(() => {
      const dataGrid = (this.$refs[this.name ?? ''] as DxDataGrid).instance;
      if (dataGrid) {
        const isFiltered = dataGrid.getCombinedFilter() !== undefined;
        const buttonElement = document.getElementById('clearFilterButton');

        if (buttonElement) {
          const iconElement = buttonElement.querySelector('.dx-icon');
          if (iconElement) {
            if (isFiltered) {
              iconElement.classList.add('filtered-icon');
              iconElement.classList.remove('unfiltered-icon');
            } else {
              iconElement.classList.add('unfiltered-icon');
              iconElement.classList.remove('filtered-icon');
            }
          }
        }
      }
    }, 0);
  }

  public removeFilters() {
    const dataGrid = (this.$refs[this.name ?? ''] as DxDataGrid).instance;
    if (dataGrid) {
      dataGrid.clearFilter();
      this.checkClearFilterButtonStyle();
    }
  }

  public toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  get selectionMode() {
    if (this.enableSelection) {
      return {
        mode: 'multiple',
        showCheckBoxesMode: 'always',
        deferred: false,
      };
    }
  }
}
